var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items && _vm.items.length)?_c('PieChart',{attrs:{"chartData":_vm.pieData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }